<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="checkedCertificates"
            :pagination.sync="pagination"
            class="elevation-1"
            hide-actions
        >
            <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.RequestedHost }}</td>
                <td class="text-xs-left">{{ props.item.ipaddress }}</td>
                <td class="text-xs-left">{{ props.item.Name }}</td>
                <td class="text-xs-left">{{ timestampToDate(props.item.Start_Date) }}</td>
                <td class="text-xs-left">{{ timestampToDate(props.item.End_Date) }}</td>
                <td class="text-xs-left">
                    <div>
                        <Icon
                            :name="sslCertificateVerfication(props.item.ssl_verify_result)"
                            width="25px"
                            height="25px"
                            :color="sslCertificateVerficationColor(props.item.ssl_verify_result)"
                        />
                        {{ checksslErrorCode(props.item.ssl_verify_result) }}
                    </div>
                </td>
                <td class="text-xs-right">
                    <div>
                        <Icon
                            :name="statusIcon(props.item.status, props.item.End_Date)"
                            width="25px"
                            height="25px"
                            :color="statusColor(props.item.status, props.item.End_Date)"
                        />
                    </div>
                </td>
            </template>
        </v-data-table>
    </div>
</template>
<script>
import Icon from '@wisol/icons'
import icons from '@wisol/icons/src/icons'
Icon.register(icons)

export default {
    components: {
        Icon
    },
    props: {
        checkedCertificates: {
            type: Array,
            required: false,
            default: null
        }
    },
    data () {
        return {
            headers: [
                { text: 'Requested Host', value: 'RequestedHost', align: 'left' },
                { text: 'Requested Host', value: 'ipaddress', align: 'left' },
                { text: 'Name', value: 'Name', align: 'left' },
                { text: 'Valid from', value: 'Start_Date', align: 'left' },
                { text: 'Valid until', value: 'End_Date', align: 'left' },
                { text: 'SSL Certificate Status', value: 'ssl_verify_result', align: 'left' },
                { text: 'Certificate Validity', value: 'status', align: 'right' }
            ],
            pagination: {
                sortBy: 'End_Date',
                totalItems: 0,
                rowsPerPage: -1,
                page: 1
            }
        }
    },
    methods: {
        // list of error codes: https://www.openssl.org/docs/man1.0.2/man1/verify.html
        checksslErrorCode (code) {
            if (!code) {
                return
            }

            if (code === 18) {
                return 'Self-signed Certificate'
            }

            if (code === 20) {
                return 'unable to get local issuer certificate'
            }

            if (code === 10) {
                return 'Certificate expired'
            }

            return 'Error Code ' + code
        },
        sslCertificateVerfication (code) {
            if (code === 0) {
                return 'fa/solid/check'
            } else if (code > 0) {
                return 'fa/solid/times'
            }
        },
        sslCertificateVerficationColor (code) {
            if (code === 0) {
                return 'green'
            } else if (code > 0) {
                return 'red'
            }
        },
        statusIcon (statusCode, validToTimestamp) {
            if (statusCode === 0) {
                if (Math.floor(Date.now()) > (validToTimestamp * 1000)) {
                    return 'fa/solid/times'
                } else {
                    return 'fa/solid/check'
                }
            }
        },
        statusColor (statusCode, validToTimestamp) {
            if (statusCode === 0) {
                if (Math.floor(Date.now()) > (validToTimestamp * 1000)) {
                    return 'red'
                } else {
                    return 'green'
                }
            }
        },
        timestampToDate (timestamp) {
            if (timestamp === 'No Timestamp') {

            } else if (timestamp) {
                var a = new Date(timestamp * 1000)
                var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                var year = a.getFullYear()
                var month = months[a.getMonth()]
                var date = a.getDate()
                var hour = a.getHours()
                var min = a.getMinutes() < 10 ? '0' + a.getMinutes() : a.getMinutes()
                var sec = a.getSeconds() < 10 ? '0' + a.getSeconds() : a.getSeconds()
                var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec
                return time
            }
        }
    }
}
</script>
<style>
</style>
